import { Link } from "react-router";
import type { ListingCard } from "../../../api/catalogue";
import { formatPesos } from "../../../lib/money";
import { SectionHeading } from "./SectionHeading";

/** The parts this visitor opened lately, at today's price. Kept in their browser only. */
export function RecentlyViewed({ listings }: { listings: ListingCard[] }) {
  return (
    <section>
      <SectionHeading title="Recently viewed" />
      <ul className="m-0 grid list-none grid-cols-2 gap-4 p-0 sm:grid-cols-3 lg:grid-cols-6 lg:gap-6">
        {listings.map((listing) => (
          <li key={listing.id}>
            <Link
              to={`/listings/${listing.id}`}
              className="flex h-full flex-col gap-1 rounded-lg border border-border-subtle bg-surface-card p-4 text-inherit shadow-sm hover:border-green-300 hover:shadow-md"
            >
              <span className="type-sku [font-size:var(--text-xs)] [overflow-wrap:anywhere] text-text-muted">{listing.reference_number ?? listing.sku}</span>
              <span className="type-body [font-size:var(--text-sm)] leading-snug text-text-strong">{listing.name}</span>
              <span className="mt-auto pt-1 type-price [font-size:var(--text-base)] text-text-strong">{formatPesos(listing.price_cents)}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
